import React, { useState } from 'react';
import { SketchPicker } from 'react-color';

export const ColorPicker = ({ value, onChange, label }) => {
  const [showPicker, setShowPicker] = useState(false);

  return (
    <div>
      <label className="block text-sm font-medium mb-2">{label}</label>
      <div className="relative">
        <button
          type="button"
          onClick={() => setShowPicker(!showPicker)}
          className="w-full px-3 py-2 border rounded-lg flex items-center justify-between"
        >
          <span className="flex items-center gap-2">
            <div
              className="w-6 h-6 rounded border"
              style={{ backgroundColor: value }}
            ></div>
            <span className="font-mono text-sm">{value}</span>
          </span>
          <span>▼</span>
        </button>
        
        {showPicker && (
          <div className="absolute z-50 mt-2">
            <div
              className="fixed inset-0"
              onClick={() => setShowPicker(false)}
            />
            <SketchPicker
              color={value}
              onChange={(color) => onChange(color.hex)}
            />
          </div>
        )}
      </div>
    </div>
  );
};
